import { apiRoutes } from "@constants/api-routes";
import { RequestTypes } from "@enums/request-types";
import { handleRequestWithBody } from "@utils/http-util";
import { injectWorkflowTemplateId } from "@utils/parameter-injector";
import {
    WorkflowTemplateDetails,
    FormattedWorkflowTemplateDetails
} from "@idw-types/data/workflow-template-details";
import { GenericNetworkResponse } from "@idw-types/generic-network-response";

type UpdateWorkflowTemplateRequestResponse = {
    transferObject: WorkflowTemplateDetails;
};

export const updateWorkflowTemplateRequest = async (
    workflowTemplate: FormattedWorkflowTemplateDetails
): Promise<GenericNetworkResponse<UpdateWorkflowTemplateRequestResponse>> => {
    const route = injectWorkflowTemplateId(
        apiRoutes.serviceConfiguration.data.workflowTemplateWithId,
        workflowTemplate.id
    );

    const body: Partial<WorkflowTemplateDetails> = {
        id: workflowTemplate.id,
        name: workflowTemplate.name,
        description: workflowTemplate.description,
        descriptionURL: workflowTemplate.descriptionURL,
        organizationID: workflowTemplate.organization?.id || null,
        template: workflowTemplate.templateString,
        status: workflowTemplate.status
    };

    const { data, error } = await handleRequestWithBody(RequestTypes.PUT, route, body);
    return { data, error, body };
};